import Vue from 'vue'
import Vuex from 'vuex'
import * as AuthType from './AuthType'
import axios from 'axios';
import moment from 'moment'
import { isValid } from '@/utils/util'

const AUTH_API_BASE = '/api/auth'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    profile: {},
    org: {}
  },
  getters: {
    isLogin: state => state.profile && state.profile.userId,
    role: state => state.profile && state.profile.role,
    profileId: state => state.profile && state.profile._id,
    isStudent: state => state.profile && (state.profile.role === 'STUDENT'),
    isTeacher: state => state.profile && (state.profile.role === 'TEACHER'),
    isStaff: state => state.profile && (state.profile.role === 'ADMIN' || state.profile.role === 'MANAGER'),
    isManager: state => state.profile && (state.profile.role === 'MANAGER'),
    isAdmin: state => state.profile && (state.profile.role === 'ADMIN')
  },
  mutations: {
    restoreAuth: (state) => {
      const org = localStorage.getItem('org')
      if (isValid(org)) {
        state.org = JSON.parse(org)
      }
    },
    clearAuth: (state) => {
      localStorage.removeItem('org')
    },
    setProfile: (state, data) => {
      state.profile = data
    },
    setOrg: (state, data) => {
      state.org = data
      localStorage.setItem('org', JSON.stringify(data))
    },
    [AuthType.LOGIN]: (state, data) => {
      localStorage.setItem('profile', JSON.stringify(data.profile))
      state.profile = data.profile;
      if (data.profile.role !== 'ADMIN') {
        state.org = data.org
        localStorage.setItem('org', JSON.stringify(data.org))
      }
    },
    [AuthType.LOGOUT]: (state) => {
      state.profile = {};
      localStorage.removeItem('profile')
      localStorage.removeItem('org')
    }
  },
  actions: {
    [AuthType.LOGIN]: async ({ commit, rootState }, user) => {
      const { data } = await axios.post(`${AUTH_API_BASE}/login`, user);
      commit(AuthType.LOGIN, data);
      if (data.profile.role === 'STUDENT' || data.profile.role === 'TEACHER') {
        rootState.training.training = data.training
        localStorage.setItem('training', JSON.stringify(data.training))
        rootState.training.subjects = data.subjects
        localStorage.setItem('subjects', JSON.stringify(data.subjects))
      }
      return data;
    },
    [AuthType.LOGOUT]: async ({ commit, rootState }) => {
      await axios.get(`${AUTH_API_BASE}/logout`);
      commit(AuthType.LOGOUT);
      rootState.training.training = {}
      rootState.training.subjects = {}
      localStorage.removeItem('training')
      localStorage.removeItem('subjects')
    },
    [AuthType.CHECK]: async ({ commit }) => {
      const { data } = await axios.post(`${AUTH_API_BASE}/check`)
      return data;
    },
    changePasswordByStaff: async ({ commit }, obj) => {
      const { data } = await axios.put(`${AUTH_API_BASE}/changepasswordbystaff`, obj)
      return data;
    }
  }
}
